import { UserManagerSettings } from 'oidc-client-ts';

/**
 * Generates OIDC configuration options with validation for required environment variables.
 *
 * @returns {UserManagerSettings} The OIDC configuration options.
 *
 * @throws {Error} If any required environment variables are missing
 */
const generateOIDCOptions = (): UserManagerSettings => {
	const authServer = import.meta.env.VITE_AUTH_SERVER || `${window.location.origin}/auth`;
	const realm = import.meta.env.VITE_AUTH_REALM;
	const clientId = import.meta.env.VITE_AUTH_CLIENT_ID;

	if (!authServer) {
		throw new Error('Missing environment authServer: VITE_AUTH_SERVER or origin');
	}

	if (!realm) {
		throw new Error('Missing environment variable: VITE_AUTH_REALM');
	}

	if (!clientId) {
		throw new Error('Missing environment variable: VITE_AUTH_CLIENT_ID');
	}

	return {
		authority: `${authServer}/realms/${realm}`,
		client_id: clientId,
		redirect_uri: window.location.origin,
		post_logout_redirect_uri: window.location.origin,
		scope: 'openid profile email',
	};
};

export default generateOIDCOptions;
